<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol>
                    <ButtonCreate
                        :title="$t('create_database')"
                        @click="
                            $router.push({
                                name: 'database_view',
                            })
                        "
                    >
                        {{ $t("create_database") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>

        <CCardBody class="main-card-body">
            <CContainer
                fluid
                class="p-0"
            >
                <!-- Filter leads -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="5" sm="12">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>

                <!-- Data chart -->
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'databases',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard class="position-relative shadow">
                            <CCardHeader>
                                <h3 class="m-0">
                                    {{ $t("database_activity") }}
                                </h3>
                            </CCardHeader>
                            <CCardBody>
                                <CChartLine
                                    style="height: 350px"
                                    :datasets="charts.databases.datasets"
                                    :labels="charts.databases.labels"
                                    :options="charts.databases.options"
                                />
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.databases.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <!-- Data table -->
                <CRow 
                    class="pt-4"
                    v-show="
                        hasItemsInTable({
                            tableName: 'databases',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CContainer fluid>
                                    <CRow>
                                        <CCol>
                                            <h3 class="m-0">
                                                {{ $t("database_list") }}
                                            </h3>
                                        </CCol>
                                        <CCol>
                                            <TableSettings
                                                :allFields="
                                                    tables.databases.allFields
                                                "
                                                :activeFields.sync="
                                                    tables.databases.fields
                                                "
                                            />
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.databases.items"
                                    :columnFilterValue.sync="
                                        tables.databases.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    :sorterValue.sync="
                                        tables.databases.sorterValue
                                    "
                                    @update:sorter-value="updateData()"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.databases.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.databases.rows"
                                    v-bind="tables.databases"
                                >
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.databases
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'databases',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.databases
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'database_view',
                                                                query: {
                                                                    view_type:
                                                                        'edit',
                                                                    database_id:
                                                                        tables
                                                                            .databases
                                                                            .itemSelected
                                                                            .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("edit_database")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #no-items-view>
                                        <slot name="no-items-view">
                                            <div class="block-no-items section">
                                                <!-- <span class="emoji">&#128557;</span> -->
                                                <br />
                                                <h2
                                                    class="
                                                        section__title
                                                        text-no-items
                                                    "
                                                >
                                                    {{
                                                        $t(
                                                            "Sorry, we haven't managed to find any results that match current filter"
                                                        )
                                                    }}
                                                </h2>
                                            </div>
                                        </slot>
                                    </template>
                                    <template #quality="{ item, index }">
                                        <td :key="'chart' + index">
                                            <ChartGauge
                                                :value="item.quality"
                                                size="sm"
                                            />
                                        </td>
                                    </template>
                                    <template #clients="{ item }">
                                        <td>
                                            <div v-if="item.clients">
                                                {{ item.clients }}
                                            </div>
                                            <div v-else>-</div>
                                        </td>
                                    </template>

                                    <template #inputs="{ item }">
                                        <td>
                                            <div v-if="item.inputs">
                                                {{ item.inputs }}
                                            </div>
                                            <div v-else>-</div>
                                        </td>
                                    </template>

                                    <template #activity="{ item }">
                                        <td class="text-center">
                                            <CSpinner
                                                v-if="item.activity > 0"
                                                grow
                                                color="success"
                                                size="sm"
                                            />
                                            <CSpinner v-else grow size="sm" />
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/dbs.api"
                                                :table="tables.databases"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter>
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.databases.page"
                                        :pages="tables.databases.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.databases.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                fluid
                class="p-0 assistant"
                v-show="
                    !hasItemsInTable({
                        tableName: 'databases',
                    })
                "
            >
                <template #title>
                    {{ $t("Create your first database") }}
                </template>
                <template #description>
                    {{
                        $t(
                            "Start creating databases to store all necessary data needed for your campaigns"
                        )
                    }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('Create my first database!')"
                        @click="
                            $router.push({
                                name: 'database_view',
                                query: { view_type: 'new' },
                            })
                        "
                    >
                        {{ $t("Create my first database!") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'databases',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('databases'),
                                updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import ChartGauge from "£lement/ChartGauge";
import { CChartLine } from "@coreui/vue-chartjs";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import TableSettings from "£lement/TableSettings";
import NoItemsContainer from "~/components/NoItemsContainer";
import { eraser } from "~/assets/icons/js/eraser";
/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/**
 * Others
 */
import { mapGetters } from "vuex";
import { cilPlus, cilSettings, cilStorage } from "@coreui/icons";
import { adapterCreatedAtInChars } from "~/utils/date";
import DatabasesTable from "./config/tables/databases";
export default {
    name: "DatabasePage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],

    components: {
        FilterDate,
        CChartLine,
        ChartGauge,
        ButtonCreate,
        ButtonExport,
        FilterFields,
        TableSettings,
        NoItemsContainer,
    },

    icons: {
        cilPlus,
        cilSettings,
        cilStorage,
        eraser,
    },

    data() {
        return {
            tables: {
                databases: DatabasesTable,
            },
            charts: {
                databases: {
                    labels: [],
                    datasets: [],
                    loading: true,
                    options: {
                        tooltips: {
                            titleMarginBottom: 10,
                            titleFontColor: "#6e707e",
                            titleFontSize: 14,
                            backgroundColor: "rgb(255,255,255)",
                            bodyFontColor: "#858796",
                            borderColor: "#dddfeb",
                            borderWidth: 1,
                            xPadding: 15,
                            yPadding: 15,
                            displayColors: false,
                            caretPadding: 10,
                        },
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                left: 10,
                                right: 25,
                                top: 25,
                                bottom: 0,
                            },
                        },
                        scales: {
                            xAxes: [
                                {
                                    time: {
                                        unit: "month",
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                    },
                                },
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        min: 0,
                                        maxTicksLimit: 15,
                                        padding: 10,
                                        // Include a dollar sign in the ticks
                                    },
                                    gridLines: {
                                        color: "rgb(234, 236, 244)",
                                        zeroLineColor: "rgb(234, 236, 244)",
                                        drawBorder: false,
                                        borderDash: [2],
                                        zeroLineBorderDash: [2],
                                    },
                                },
                            ],
                        },
                    },
                },
            },
            urls: {
                databases: "/dbs.api",
                external_user_info: "/db_external_user_info",
            },
            intervalActivity: null,
            activity: [],
            page: {
                _loading: true,
            },
        };
    },
    computed: {
        ...mapGetters({
            default_colors: "global/default_colors",
            from: "filter/from",
            to: "filter/to",
        }),
    },
    watch: {
        activity(newValue) {
            for (let index = 0; index < newValue.length; index++) {
                const element = newValue[index];
                this.tables.databases.items[index].activity = element;
            }
        },
    },
    methods: {
        async updateData() {
            /* Load table of database */

            await this.updateTable({
                tableName: "databases",
                url: "/dbs.api",
            });
            this.clearIntervalActivity(); // To update data always clear the interval.
            this.checkActivity(); // Init activity checker.
            this.tables.databases.itemSelected = null;
            this.loadLanguageInTable({
                tableName: "databases",
                fielLanguageName: "language_id"
            });
            this.loadCountryInTable({
                tableName: "databases",
                fielCountryName: "country_id"
            });
            /* Load Data chart */
            await this.loadChartDbExternalUserInfo({
                from: this.from,
                to: this.to,
            });
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        async loadChartDbExternalUserInfo({ from, to }) {
            this.charts.databases.loading = true;
            let listData = this.tables.databases.items;
            let fetcherCollection = listData.map((item) => {
                return {
                    url: `/dbs.api/${item.uuid}/statistics/history`,
                    query: {
                        query: this.createQuery({
                            where: {
                                created_at: {
                                    between: [from, to, false],
                                },
                            },
                        }),
                    },
                };
            });

            let chartData = await this.mapFetcher(fetcherCollection);

            adapterCreatedAtInChars(chartData);
            let labels_dataset = listData.map((item) => item.name);
            this.loadChart({
                chart_name: "databases",
                labels_dataset,
                chart_data: chartData,
                field_chart_data: "count",
                filed_chart_label: "created_at",
                colors: this.default_colors,
            });
        },
        getBadge(status) {
            switch (status) {
                case "Active":
                    return "success";
                case "Inactive":
                    return "secondary";
                case "Pending":
                    return "warning";
                case "Banned":
                    return "danger";
                default:
                    "primary";
            }
        },

        clearIntervalActivity() {
            if (this.intervalActivity) {
                clearInterval(this.intervalActivity);
            }
        },
        checkActivity(intervalTime = 60000) {
            // this.serviceActivityChecker();
            this.intervalActivity = setInterval(() => {
                this.serviceActivityChecker();
            }, intervalTime);
        },
        async serviceActivityChecker() {
            let dbs = this.tables.databases.items;
            let activity = [];
            for (let index = 0; index < dbs.length; index++) {
                const db = dbs[index];
                let data = await this.loadData({
                    url: "/getDbActivity",
                    url_param: db.uuid,
                });
                activity.push(data[0].activity_count);
            }
            this.activity = activity;
        },
    },
    mounted() {
        this.updateData();
        this.checkActivity();
    },
    created(){
        this.loadLanguages();
        this.loadCountries();
    },
    beforeDestroy() {
        this.clearIntervalActivity();
    },
};
</script>
<style scoped lang="scss">
.empty-data {
    text-align: "center";
}
</style>
